import { RuntimeLoader } from '@rive-app/react-canvas';

import { RIVE_WASM_RESOURCE } from './constants';

// Module-level side effect: registers the WASM URL on first import so every
// entry point (Landing, Casino, micro-frontends) hits our CDN instead of the
// @rive-app default unpkg URL. RuntimeLoader is a singleton; repeat assignment
// is idempotent.
RuntimeLoader.setWasmUrl(RIVE_WASM_RESOURCE);
